module.exports = __webpack_public_path__ + "static/base-4-fe6f3f157e7dddf73a33b467de2a286d.jpg";